module.exports = __webpack_public_path__ + "media/ס.84ccd9d6.mp3";